/**
 * Base class for ShaderAccessors to updates the shader buffers
 */
export class ShaderAccessor {
    constructor(_echoIdx) {
        this._echoIdx = _echoIdx;
        this._shaderMaterial = null;
    }
    setPolarScan(polarScan) {
        this._polarScan = polarScan;
    }
    getMaterial() {
        return this._shaderMaterial;
    }
}
//# sourceMappingURL=ShaderAccessor.js.map